import { render, staticRenderFns } from "./userRelation.vue?vue&type=template&id=01f8078d&scoped=true&"
import script from "./userRelation.vue?vue&type=script&lang=js&"
export * from "./userRelation.vue?vue&type=script&lang=js&"
import style0 from "./userRelation.vue?vue&type=style&index=0&id=01f8078d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f8078d",
  null
  
)

export default component.exports